export const MAIN_CLASS_NAME = 'check-list-item';
export const DISABLED_CLASS_NAME = `${MAIN_CLASS_NAME}_disabled`;
export const DRAGGING_CLASS_NAME = `${MAIN_CLASS_NAME}_dragging`;
export const HEADER_CLASS_NAME = `${MAIN_CLASS_NAME}__header`;
export const ORDER_CLASS_NAME = `${HEADER_CLASS_NAME}__order`;
export const DRAG_HANDLE_CLASS_NAME = `${HEADER_CLASS_NAME}__drag-handle`;
export const DRAG_HANDLE_DISABLED_CLASS_NAME = `${DRAG_HANDLE_CLASS_NAME}_disabled`;
export const DRAG_HANDLE_ICON_CLASS_NAME = `${DRAG_HANDLE_CLASS_NAME}__icon`;
export const TITLE_CLASS_NAME = `${HEADER_CLASS_NAME}__title`;
export const CONTEXT_CLASS_NAME = `${HEADER_CLASS_NAME}__context`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
export const SUMMARY_CLASS_NAME = `${FOOTER_CLASS_NAME}__summary`;
export const SUMMARY_TABLE_CLASS_NAME = `${SUMMARY_CLASS_NAME}__table`;
export const SUMMARY_ITEM_CLASS_NAME = `${SUMMARY_CLASS_NAME}__item`;
export const SUMMARY_ITEM_LABEL_CLASS_NAME = `${SUMMARY_ITEM_CLASS_NAME}__label`;
export const SUMMARY_ITEM_VALUE_CLASS_NAME = `${SUMMARY_ITEM_CLASS_NAME}__value`;
export const SUMMARY_ITEM_VALUE_ICON_CLASS_NAME = `${SUMMARY_ITEM_VALUE_CLASS_NAME}__icon`;
export const SUMMARY_PROMPT_CLASS_NAME = `${SUMMARY_CLASS_NAME}__prompt`;
export const SUMMARY_PROMPT_LABEL_CLASS_NAME = `${SUMMARY_PROMPT_CLASS_NAME}__label`;
export const SUMMARY_PROMPT_VALUE_CLASS_NAME = `${SUMMARY_PROMPT_CLASS_NAME}__value`;
export const TOOLTIP_CLASS_NAME = `${MAIN_CLASS_NAME}__tooltip`;
